import { getApiBaseUrl } from "../config";

let cachedModulesPayload = null;
let inFlightPromise = null;

const fetchMyModulesPayload = async () => {
  const response = await fetch(`${getApiBaseUrl()}/auth/my-modules`, {
    credentials: "include",
  });

  if (!response.ok) {
    throw new Error("Failed to fetch my modules");
  }

  return response.json();
};

export const getMyModulesOnce = async (options = {}) => {
  const { force = false } = options;

  if (!force && cachedModulesPayload) {
    return cachedModulesPayload;
  }

  if (!force && inFlightPromise) {
    return inFlightPromise;
  }

  inFlightPromise = fetchMyModulesPayload()
    .then((payload) => {
      cachedModulesPayload = payload;
      return payload;
    })
    .finally(() => {
      inFlightPromise = null;
    });

  return inFlightPromise;
};

export const clearMyModulesCache = () => {
  cachedModulesPayload = null;
  inFlightPromise = null;
};
